export const titleStyle = {
  fill: {
    fgColor: { rgb: 'EAF5DA' }
  },
  font: {
    bold: true,
  },
  border: {
    bottom: { style: "thin", color: { rgb: "000000" } },
    top: { style: "thin", color: { rgb: "000000" } },
  }
};
export const headerStyle = {
  fill: {
    fgColor: { rgb: 'E8F3FA' }
  },
  font: {
    bold: true,
  },
  border: {
    bottom: { style: "thin", color: { rgb: "000000" } },
    top: { style: "thin", color: { rgb: "000000" } },
  }
};
export const sectionStyle = {
  fill: {
    fgColor: { rgb: 'f9fde5' }
  },
  font: {
    bold: true,
  },
  border: {
    bottom: { style: "thin", color: { rgb: "000000" } },
    top: { style: "thin", color: { rgb: "000000" } },
  }
};
export const contentStyle = {
  fill: {
    fgColor: { rgb: 'FFF7E6' }
  },
  font: {
    bold: true,
  },
  border: {
    bottom: { style: "thin", color: { rgb: "000000" } },
    top: { style: "thin", color: { rgb: "000000" } },
  }
}
export const daypartStyle = {
  fill: {
    fgColor: { rgb: 'eee8fc' }
  },
  font: {
    bold: true,
  },
  border: {
    bottom: { style: "thin", color: { rgb: "000000" } },
    top: { style: "thin", color: { rgb: "000000" } },
  },
}
export const subContentStyle = {
  fill: {
    fgColor: { rgb: 'f8fde9' }
  },
  font: {
    bold: true,
  },
  border: {
    bottom: { style: "thin", color: { rgb: "000000" } },
    top: { style: "thin", color: { rgb: "000000" } },
  }
}
export const categoryStyle = {
  fill: {
    fgColor: { rgb: 'ffefde' }
  },
  font: {
    bold: true,
  },
  border: {
    bottom: { style: "thin", color: { rgb: "000000" } },
    top: { style: "thin", color: { rgb: "000000" } },
  }
}

export const dishStyle = {
  fill: {
    fgColor: { rgb: 'faf86e' }
  },
  border: {
    bottom: { style: "thin", color: { rgb: "000000" } },
    top: { style: "thin", color: { rgb: "000000" } },
  }
}

// Helper: return a set of styles specifically for the "Export MP Data" report
// This keeps existing shared exports unchanged so other pages are not affected.
export function getMPReportStyles() {
  const reportSectionStyle = {
    fill: {
      fgColor: { rgb: 'FFF2CC' } // warm light tone specifically for this report
    },
    font: {
      bold: true,
    },
    border: {
      bottom: { style: "thin", color: { rgb: "000000" } },
      top: { style: "thin", color: { rgb: "000000" } },
    }
  };

  const reportItemStyle = {
    fill: {
      fgColor: { rgb: 'F0E6FF' } // distinct, non-conflicting lavender for item rows
    },
    font: {
      bold: true,
    },
    border: {
      bottom: { style: "thin", color: { rgb: "000000" } },
      top: { style: "thin", color: { rgb: "000000" } },
    }
  };

  const reportCategoryStyle = {
    fill: {
      fgColor: { rgb: 'FFEFDE' } // warm peach for category rows (distinct from item)
    },
    font: {
      bold: true,
    },
    border: {
      bottom: { style: "thin", color: { rgb: "000000" } },
      top: { style: "thin", color: { rgb: "000000" } },
    }
  };

  const reportContentStyle = {
    fill: {
      fgColor: { rgb: 'FFFFFF' } // keep white for variant rows so font appears normal
    },
    font: {
      bold: false, // do NOT change font style for variant/dish rows
    },
    border: {
      bottom: { style: "thin", color: { rgb: "000000" } },
      top: { style: "thin", color: { rgb: "000000" } },
    }
  };

  const reportSubContentStyle = {
    fill: {
      fgColor: { rgb: 'FFFFFF' }
    },
    font: {
      bold: false,
    },
    border: {
      bottom: { style: "thin", color: { rgb: "000000" } },
      top: { style: "thin", color: { rgb: "000000" } },
    }
  };

  return {
    // expose shared styles if consumers want them via import;
    // return only uniquely named per-report overrides here to avoid duplicate keys
    reportSectionStyle: reportSectionStyle,
    reportItemStyle: reportItemStyle,
    reportCategoryStyle: reportCategoryStyle,
    reportContentStyle: reportContentStyle,
    reportSubContentStyle: reportSubContentStyle,
  };
}